// extracted by mini-css-extract-plugin
export default {"page-layout":"styles_page-layout__h21MC","database-main":"styles_database-main__58Gsc"};